import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';
import { fragmentMatcher } from './graphql/fragments';
import { getGlobalContext } from '@/utils/window';
import { onError } from 'apollo-link-error';
import { setContext } from 'apollo-link-context';

import { reportError } from '@/utils/error';
import { logout } from '@/utils/logout';
import { LayoutStoreInstance } from './LayoutStore';
import i18n from '@/utils/i18n';

let apolloUri = localStorage.getItem('pickpack-endpoint');
const apolloUriValue = apolloUri || '';
window.__pp_stage =
  apolloUriValue.includes('colugo.vytal.org') ||
  apolloUriValue.includes('colugo.pickpack.de')
    ? 'PROD'
    : 'DEV';
if (!apolloUri) {
  apolloUri = setPickpackEndpoint();
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

let token = null;

const authLink = setContext(async (_, { headers }) => {
  try {
    if (token === null) {
      token = getCookie('jwt');
    }
    if (!token) {
      console.warn('No jwt has been provided via cookies');
      logout();
    }

    const authHeader = `Bearer ${token}`;
    return {
      headers: {
        ...headers,
        authorization: authHeader,
        'Accept-Language': getGlobalContext().pickpackLocale || 'de',
        'client-name': 'vytal-admin-web',
        'posing-role': getGlobalContext().posingRole,
      },
    };
  } catch (err) {
    console.log('AuthContextErr', err);
    reportError('AuthContextError', err);
    throw new Error(err);
  }
});

let pleaseLoginMsgShown = false;
const errorLink = onError(
  ({ graphQLErrors, networkError, operation, forward }) => {
    if (networkError) {
      console.log(`[Network error]: ${networkError}`);
    }

    if (networkError && networkError.result) {
      if (networkError.result.message === 'Unauthorized') {
        if (!pleaseLoginMsgShown) {
          pleaseLoginMsgShown = true;
          alert('Unauthorized. Your session expired. Please log in again.');
        }
        logout();
      }
    }

    if (graphQLErrors) {
      if (
        graphQLErrors.some((e) =>
          JSON.stringify(e).toLowerCase().includes('unauthorize'),
        )
      ) {
        LayoutStoreInstance.setError(i18n.t('Common:unauthorized'));
      }

      graphQLErrors.map((error) =>
        reportError(`[GraphQL error]: Message: ${JSON.stringify(error)}`),
      );
      console.log('errorLink', graphQLErrors);
    }
  },
);

const httpLink = new HttpLink({ uri: apolloUri });

const cache = new InMemoryCache({
  dataIdFromObject: (object) => {
    if (!object || !object.__typename) return null;
    switch (object.__typename) {
      case 'BasketItem':
        return object.id ? `BasketItem:${object.id}` : null;
      case 'Extra':
        return object.extra_id ? `Extra:${object.extra_id}` : null;
      default:
        return object.id ? `${object.__typename}:${object.id}` : null;
    }
  },
  fragmentMatcher,
  cacheRedirects: {
    Query: {
      product: (_, args, { getCacheKey }) =>
        getCacheKey({ __typename: 'Product', id: args.id }),
      store: (_, args, { getCacheKey }) =>
        getCacheKey({ __typename: 'Store', id: args.id }),
      order: (_, args, { getCacheKey }) =>
        getCacheKey({ __typename: 'Order', id: args.id }),
    },
  },
});

const client = new ApolloClient({
  link: authLink.concat(errorLink).concat(httpLink),
  // @FIXME: https://github.com/apollographql/apollo-server/issues/3058
  // name: 'web',
  // version: '2.6.3',
  cache: cache,
  //defaultHttpLink: false,
  //resolvers,
});

export default client;
